import { render, staticRenderFns } from "./AutorespondersAttributes.vue?vue&type=template&id=f30f9350"
import script from "./AutorespondersAttributes.vue?vue&type=script&lang=js"
export * from "./AutorespondersAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports